export const SET_ACTIVE_SPOT = 'SET_ACTIVE_SPOT';
export const CLEAR_ACTIVE_SPOT = 'CLEAR_ACTIVE_SPOT';
export const SCROLL_TO_SPOT = 'SCROLL_TO_SPOT';
export const SET_SCROLL_POSITION = 'SET_SCROLL_POSITION';

export const setActiveSpot = spotId => ({
  type: SET_ACTIVE_SPOT,
  spotId,
});

export const clearActiveSpot = () => ({
  type: CLEAR_ACTIVE_SPOT,
});

export const scrollToSpot = spotId => ({
  type: SCROLL_TO_SPOT,
  spotId,
});

export const setSpotListScrollPosition = scrollPosition => ({
  type: SET_SCROLL_POSITION,
  component: 'spotList',
  scrollPosition,
});

export const setCamListScrollPosition = scrollPosition => ({
  type: SET_SCROLL_POSITION,
  component: 'camList',
  scrollPosition,
});
